export default __webpack_public_path__ + "static/tuha-95c0613e2d20c780adad744fda71e411.png";